<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Day Force Id-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="dayForceId">Day Force Id :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="dayForceId" type="text" class="form-control" id="dayForceId" placeholder="Day Force Id">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{dayForceIdError}}</font>
                                </div>
                            </div>
                            <!--Designation-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="contactEmail">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{contactEmailError}}</font>
                                </div>
                            </div>
                            <!--First Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="firstName">First Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="firstName" type="text" class="form-control" id="firstName" placeholder="First Name">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{firstNameError}}</font>
                                </div>
                            </div>
                            <!--Last Name-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="lastName">Last Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="lastName" type="text" class="form-control" id="lastName" placeholder="Last Name">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{lastNameError}}</font>
                                </div>
                            </div>
                            <!--Reporting User-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="username">Reporting To :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="reportTo"
                                                  @change="changedValue"
                                                  @input="changedValueUser()"
                                                  name="reportTo"
                                                  id="reportTo"
                                                  label="text"
                                                  :filterable="false"
                                                  :options="reportToArr"
                                                  @search="onSearchUser"
                                                  placeholder="Select User">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <!--div class="requiredstar">*</div>
                                        <font class="text-danger">{{reportToError}}</font-->
                                </div>
                            </div>
                            <!--Designation-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Designation :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="roleId"
                                              @change="changedValue"
                                              @input="changedValueRole()"
                                              name="roleId"
                                              id="roleId"
                                              label="text"
                                              :filterable="false"
                                              :options="roleArr"
                                              @search="onSearchRole"
                                              placeholder="Select Role">
                                        <template slot="no-options">
                                            Search Role...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{designationError}}</font>
                                </div>
                            </div>
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="siteId">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="siteId"
                                              @input="changedValueSite()"
                                              name="siteId"
                                              id="siteId"
                                              label="text"
                                              :options="siteArr"
                                              :searchable="false"
                                              :filterable="false"
                                              placeholder="Select Location">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{siteError}}</font>
                                </div>
                            </div>
                            <!--Department-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="departmentId">Department :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="departmentId"
                                              @input="changedValueDepartment()"
                                              name="departmentId"
                                              id="departmentId"
                                              label="text"
                                              :options="departmentArr"
                                              :searchable="false"
                                              :filterable="false"
                                              placeholder="Select Department">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{departmentError}}</font>
                                </div>
                            </div>
                            <!--Post-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="post">Post :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="post" type="text" class="form-control" id="post" placeholder="Post" maxlength="190">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{postError}}</font>
                                </div>
                            </div>

                            <!-- <div  class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" >Is allow ERG: </div>
                                        </div>
                                    <div class=" col- paddingright0">
                                        <input type="checkbox"  name="allow_erg" id="allow_erg" v-model='allow_erg'>
                                    </div>

                           </div> -->

                            <!--Profile Picture-->
                            <template v-show="isVisibleManagers">
                              <div class="col-12 forms-block" id="pro_pic_id">
                                  <div class="col-3 paddingleft0">
                                      <div class="form-label" for="drop1">Profile Picture :</div>
                                  </div>
                                  <div class="col-9 paddingleft0">
                                      <vue-dropzone
                                          id="drop1"
                                          :options="dropzoneOptions"
                                          ref="dropzone"
                                          :destroyDropzone="false"
                                          :headers="dropzoneOptions.headers"
                                          @vdropzone-removed-file="removedSelectedFile"
                                          @vdropzone-success="vfileSuccess"
                                          name="file"
                                          >
                                      </vue-dropzone>
                                      <font class="text-danger"> <strong id="uploadErrorMsg" class="error text-danger"></strong></font>
                                  </div>
                              </div>
                              <!--Crop Profile Image-->
                              <div class="col-6 forms-block">
                                  <div class="col-12 paddingleft0">
                                      <vue-croppie
                                          ref="croppieRef"
                                          id="vuecrop"
                                          :viewport="{width:276, height: 312, type: 'square'}"
                                          :boundary="{ width: 286, height: 322 }"
                                          :enableResize="false"
                                          @result="result"
                                          @update="update" ></vue-croppie>
                                  </div>
                              </div>
                              <div class="col-6 forms-block">
                                  <div class="col-12 paddingleft0">
                                      <button class="btn-croppie" id="rotateAnti" type="button" @click="rotate(-90)" title="Rotate Left"><i aria-hidden="true" class="fa fa-repeat"></i></button>
                                      <button class="btn-croppie" id="rotateClock" type="button" @click="rotate(90)" title="Rotate Right"><i aria-hidden="true" class="fa fa-undo"></i></button>
                                      <button class="btn-croppie" id="crop" type="button" @click="crop()" title="Crop"><i class="fa fa-crop" aria-hidden="true"></i></button>
                                      <br/>
                                      <img v-bind:src="cropped" width="200"/>
                                      <font class="text-danger">{{cropError}}</font>
                                  </div>
                              </div>
                            </template>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addNotRegisterdUser()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addNotRegisterdUser(flag='Save and Continue')">
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from 'vue';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';

    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';


    import EventBus from '../../event-bus';

    export default {
        name: 'AddBenefits',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                contactEmail: '',
                contactEmailError: '',
                contactNumberError: '',
                date: '',
                pageTitle: 'Add New User To Register',

                //V-model
                firstName: '',
                lastName: '',
                dayForceId: '',
                roleId: '',
                roleArr: [],
                locationId: '',
                locationArr: [],
                siteFirstLoad: 0,
                siteId: '',
                siteArr: [],
                departmentFirstLoad: 0,
                departmentId: '',
                departmentArr: [],
                post: '',
                // allow_erg:'',

                //Errors
                firstNameError: '',
                lastNameError: '',
                dayForceIdError: '',
                designationError: '',
                locationError: '',
                siteError: '',
                departmentError: '',
                postError: '',
                isAdd : true,

                reportTo : "",
                reportToArr : [],
                reportToError : '',


                //DropZone
                dropzoneOptions: {
               // url: "https://httpbin.org/post",
                    url: process.env.ROOT_API + "/uploadmedia",
                    timeout: 3000000,
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 8, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                cropped: null,
                profileImages: [],
                croppedProfileImage: '',
                isCropped: false,
                isFileUploaded: false,
                cropError: '',

                imageURL: '',
                isDropFileUploaded: false,
                filePath: '',


                year: '',
                from: '',
                isTalentProfile: false,
                user_id_edit : 0,

                isVisibleManagers: false,
                loginUserRoleId: 0,

            }
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.showLoader();
            self.loadLocationsAdd();
            self.loadRoleAdd();
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatenotregistereduser') {
                if (segments[3]) {
                    self.loadNotRegisterdUser();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit New User To Register";
                    self.user_id_edit = segments[3];
                }
            } else {
                self.hideLoader();
            }

            if(this.$route.query.from) {
              self.from = this.$route.query.from;
              self.year = this.$route.query.year;
              self.isTalentProfile = true;
              self.scrollToProfilePic();
            }

            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#roleId").on('keyup', function () {
                self.designationError = '';
            });
            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#siteId").on('keyup', function () {
                self.siteError = '';
            });
            $("#departmentId").on('keyup', function () {
                self.departmentError = '';
            });
            $("#firstName").on('keyup', function () {
                self.firstNameError = '';
            });
            $("#lastName").on('keyup', function () {
                self.lastNameError = '';
            });
            $("#dayForceId").on('keyup', function () {
                self.dayForceIdError = '';
            });
            $("#post").on('keyup', function () {
                self.postError = '';
            });
            /*$("#roleData").change(function () {
             self.designationError = '';
             });*/


            $("#alertError").hide();

            $("#vuecrop").hide();
            $("#rotateAnti").hide();
            $("#rotateClock").hide();
            $("#crop").hide();

            $("#browse").on('change', function () {
                self.readFile(this);
                $("#vuecrop").show();
                $("#rotateAnti").show();
                $("#rotateClock").show();
                $("#crop").show();
            });


        },
        watch: {
            dayForceId: function (dayForceId) {
                if (dayForceId.length > 3) {
                    var fields = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            dayforceid: dayForceId,
                        }
                    };
                    //console.log(self.username.length);
                    HTTP.get("/getssouser", fields)
                            .then(function (response) {
                                //console.log("success");
                                if (response.data.code === 200) {
                                    if (response.data.content.username != null && response.data.content.username != '') {
                                        self.contactEmail = response.data.content.username;
                                    }
                                    if (typeof (response.data.content.first_name) != "undefined" && response.data.content.first_name != null && response.data.content.first_name != 'null' && response.data.content.first_name != '') {
                                        self.firstName = response.data.content.first_name;
                                    }
                                    if (typeof (response.data.content.last_name) != "undefined" && response.data.content.last_name != null && response.data.content.last_name != 'null' && response.data.content.last_name != '') {
                                        self.lastName = response.data.content.last_name;
                                    }
                                }
                            })
                            .catch(function (err) {
                                //console.log('Request Status : ' + err.response.status);
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        //localStorage.removeItem("user_obj");
                                        //localStorage.removeItem("api_token");
                                        //localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    //console.log(JSON.stringify(err.response.data));
                                    self.error = err.response.data.message;
                                }
                            });
                } else {
                    self.firstName = self.email = self.lastName = "";
                    $('#email').prop("disabled", false);
                    self.loadLocations();
                }
            },
            locationId: function (locationId) {
                var location = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        location: location
                    }
                };
                HTTP.get("getsite", config)
                        .then(function (response) {
                            self.siteArr = response.data.content;
                            var path = window.location.pathname;
                            var segments = path.split("/");
                            if (segments[2] != 'updatenotregistereduser' || self.siteFirstLoad > 0) {
                                self.siteId = {
                                    value: response.data.content[0].value,
                                    text: response.data.content[0].text,
                                };
                            }
                            self.siteFirstLoad = 1;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            siteId: function (siteId) {
                var site = (self.siteId === null || self.siteId == '') ? 0 : self.siteId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        site: site
                    }
                };
                HTTP.get("getdepartment", config)
                        .then(function (response) {
                            self.departmentArr = response.data.content;
                            var path = window.location.pathname;
                            var segments = path.split("/");
                            if (segments[2] != 'updatenotregistereduser' || self.departmentFirstLoad > 0) {
                                self.departmentId = {
                                    value: response.data.content[0].value,
                                    text: response.data.content[0].text,
                                };
                            }
                            self.departmentFirstLoad = 1;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            }
        },
        methods: {
            scrollToProfilePic: function(){
                $('html, body').animate({
                  scrollTop: $("#pro_pic_id").offset().top
                },1000);
            },
            changedValueUser: function () {
                self.reportToError = "";
            },
            onSearchUser(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadUsers(loading, search, this);
                }
                /*}*/
            },
            loadUsers(loading, search, vm) {
                let self = this;
                var siteId = "";
                var departmentId = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    search: search,
                    except_self : 1,
                };
                HTTP.post("getusersdropdown", fields,config)
                        .then(function (response) {
                            self.reportToArr = [];
                            $.each(response.data.content, function (i) {
                                self.reportToArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            buttonBack() {
                $(".back_button").prop("disabled", false);
                if(self.isTalentProfile) {
                self.$router.push("/backend/talentprofile?id=" + self.user_id_edit + "&from=9box&year=" + self.year);
              } else {
                self.$router.push('/backend/listnotregistereduser');
              }

            },
            changedValue: function (value) {
                //console.log(value);
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            onSearchRole(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            changedValueSite: function () {
                self.siteError = "";
            },
            changedValueDepartment: function () {
                self.departmentError = "";
            },
            changedValueRole: function () {
                self.designationError = "";
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            checkForm: function () {
                var checked = true;
                if (!self.contactEmail) {
                    self.contactEmailError = 'Email Required';
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.contactEmail)) {
                    self.contactEmailError = 'Please Enter Valid Contact Email';
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.locationId) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.siteId) {
                    self.siteError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.departmentId) {
                    self.departmentError = "Department Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.firstName) {
                    self.firstNameError = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.lastName) {
                    self.lastNameError = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.dayForceId) {
                    self.dayForceIdError = "Day ForceId Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.roleId) {
                    self.designationError = "Designation Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.post) {
                    self.postError = "Post Required";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            loadRoleAdd() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            //self.roleArr = response.data.content;
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                    self.roleId = response.data.content[i];
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                            /*self.roleArr = response.data.content;*/
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            /*self.locationArr = response.data.content;*/
                            self.locationArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadNotRegisterdUser() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getnotregisteredusers/" + segments[3], data, config)
                        .then(function (response) {
                          console.log(response.data);
//                        self.locationId = response.data.content[0].location_name;
                            self.firstName = response.data.content[0].first_name;
                            self.lastName = response.data.content[0].last_name;
                            self.siteId = {
                                value: response.data.content[0].site_id,
                                text: response.data.content[0].site_name,
                            };
                            self.departmentId = {
                                value: response.data.content[0].department_id,
                                text: response.data.content[0].department_name,
                            };
                            self.locationId = {
                                value: response.data.content[0].location_id,
                                text: response.data.content[0].location_name,
                            };
                            self.dayForceId = response.data.content[0].dayforce_id;
                            self.roleId = {
                                value: response.data.content[0].role_id,
                                text: response.data.content[0].role_name,
                            };
                            if(response.data.content[0].reporting_to_id != null && response.data.content[0].reporting_to_id != 'null' && response.data.content[0].reporting_to_id != ''){
                                self.reportTo = {
                                    value: response.data.content[0].reporting_to_id,
                                    text: response.data.content[0].reporting_to,
                                }
                            }
                            self.post = response.data.content[0].post;
                            self.allow_erg=response.data.content[0].allow_erg;
                            self.filePath = response.data.content[0].profile_image;
                            if (self.filePath != '') {
                                self.isFileUploaded = true;
                                self.isDropFileUploaded == true;
                                self.imageSize = response.data.content[0].image_size;
                                self.isCropped = true;
                                self.uploadManually();
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {

                          console.log(err);

                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            uploadManually(file) {
                if (self.filePath != '') {
                    var file_name = self.getFileName(self.filePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.filePath;
                    let file_size = self.imageSize;
                    //console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },
            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            addNotRegisterdUser(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var status = document.getElementById("status");
                    var type = document.getElementById("type");
                    // console.log("allow_erg"+allow_erg);
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };

                    if (segments[2] == 'updatenotregistereduser') {
                        if (segments[3]) {
                            var data = {
                                first_name: self.firstName,
                                last_name: self.lastName,
                                dayforce_id: self.dayForceId,
                                // allow_erg:self.allow_erg,
                                locationId: self.locationId.value,
                                designation: self.roleId.value,
                                site: self.siteId.value,
                                department: self.departmentId.value,
                                email: self.contactEmail,
                                post: self.post,
                                report_to : self.reportTo.value,
                                id: segments[3],
                                profile_image: self.croppedProfileImage,
                                filePath: self.filePath,
                                imageSize: self.imageSize,
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            first_name: self.firstName,
                            last_name: self.lastName,
                            dayforce_id: self.dayForceId,
                            // allow_erg:self.allow_erg,
                            locationId: self.locationId.value,
                            designation: self.roleId.value,
                            site: self.siteId.value,
                            department: self.departmentId.value,
                            email: self.contactEmail,
                            post: self.post,
                            report_to : self.reportTo.value,
                            profile_image: self.croppedProfileImage,
                            filePath: self.filePath,
                            imageSize: self.imageSize,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }

                    self.showLoader();
                    HTTP.post("addnotregistereduser", data, config)
                            .then(function (response) {
                                if (segments[2] == 'updatenotregistereduser') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        allow_erg='';
                                        self.firstName = '';
                                        self.lastName = '';
                                        self.dayForceId = '';
                                        self.alertdayForceId = '';
                                        self.roleId = '';
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 3000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatenotregistereduser') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.locationId = '';
                                            self.allow_erg='';
                                            self.firstName = '';
                                            self.lastName = '';
                                            self.dayForceId = '';
                                            self.roleId = '';
                                            $("#status option[value='']").attr('selected', true);
                                            $("#type option[value='']").attr('selected', true);

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.firstName = '';
                                        self.allow_erg='';
                                        self.lastName = '';
                                        self.dayForceId = '';
                                        self.roleId = '';
                                        $("#status option[value='']").attr('selected', true);
                                        $("#type option[value='']").attr('selected', true);

                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            removedSelectedFile(file, xhr, error) {
                self.isFileUploaded = false;
                self.isDropFileUploaded = false;
                self.isCropped = false;
                var filePath = JSON.parse(file.xhr.response);
                self.imageURL = '';
                self.imageSize = '';
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
                $("#vuecrop").hide();
                $("#rotateAnti").hide();
                $("#rotateClock").hide();
                $("#crop").hide();
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                    // console.log("File removed successfully");
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                self.cropError = '';
                $("#uploadErrorMsg").html('');
                if (self.isDropFileUploaded == false) {
                    self.imageURL = file.dataURL;
                    self.isDropFileUploaded = true;
                    self.isFileUploaded = true;
                    self.$refs.croppieRef.bind({
                        url: self.imageURL,
                    });
                    $("#vuecrop").show();
                    $("#rotateAnti").show();
                    $("#rotateClock").show();
                    $("#crop").show();
                    var filePathJSON = JSON.parse(file.xhr.response);
                    self.filePath = filePathJSON.content.media_path;
                    self.imageSize = file.size;
                } else if (self.isDropFileUploaded == true) {
                    self.removedSelectedFile(file);
                    var err = "You can Upload Only One Image";
                    $("#uploadErrorMsg").html(err);
                }
            },
            // CALBACK USAGE
            crop() {
                // Here we are getting the result via callback function
                // and set the result to this.cropped which is being
                // used to display the result above.
                self.isCropped = true;
                let options = {
                    format: 'jpeg',
                    circle: false,
                }
                self.$refs.croppieRef.result(options, (output) => {
                    self.cropped = output;
                    self.croppedProfileImage = self.cropped;
                    self.cropError = "";
                });
            },
            // EVENT USAGE
            result(output) {
                self.cropped = output;
            },
            update(val) {
                //console.log(val);
            },
            rotate(rotationAngle) {
                // Rotates the image
                self.$refs.croppieRef.rotate(rotationAngle);
            }

        }
    }

    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.loginUserRoleId = id;
            if(self.loginUserRoleId <= 1) {
              self.isVisibleManagers = true;
            }
            // self.loadUsers(true, '', this)
            console.log('self.roleId ==', self.loginUserRoleId);

            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/notregisteredusers/AddNotRegisteredUser.vue